'use strict';

require('./performance-review-agreement-summary.scss');

module.exports = {
  template: require('./performance-review-agreement-summary.html'),
  controller: require('./performance-review-agreement-summary.controller'),
  controllerAs: 'vm',

  bindings: {
    data: '<',
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-agreement-summary/index.js
 ** module id = 298
 ** module chunks = 0
 **/